<template>
    <div>   
        <vs-table>
            <template #thead>
            <vs-tr>
                <vs-th>
                    Institución
                </vs-th>
                <vs-th>
                    Programa
                </vs-th>
                <vs-th>
                    Oferta Académica
                </vs-th>
                <vs-th>
                    No. Prospectos
                </vs-th>
                <vs-th>
                    Acciones
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in users"
                :data="tr"
            >
                <vs-td>
                    <h6>{{tr.ciclo_escolar.nombre_ciclo}}</h6>
                    <p>{{tr.institucion.nombre}}</p>
                </vs-td>
                <vs-td>
                    <h6>{{tr.programa.nombre}}</h6>
                    <p><i>Turno:</i>{{tr.turno.turno}}</p>
                </vs-td>
                <vs-td>
                    <h6>{{tr.nombre}}</h6>
                </vs-td>
                <vs-td>
                    <h6>{{tr.numeroProspectos}}</h6>
                </vs-td>
                <vs-td>
                    <div class="d-flex">
                        <vs-tooltip>
                            <vs-button
                                icon
                                color="success"
                                flat
                                size="small"
                                @click="activeEditar =! activeEditar; selectArrow = tr"
                            >
                                <i class="fas fa-edit" style="font-size: 12px;"></i>
                            </vs-button>
                            <template #tooltip>
                                Editar registro
                            </template>
                        </vs-tooltip>

                        <vs-tooltip>
                            <vs-button
                                v-if="tr.numeroProspectos == 0"
                                icon
                                color="danger"
                                flat
                                size="small"
                                @click="activeEliminar =! activeEliminar; selectArrow = tr"
                            >
                                <i class="fas fa-trash-alt" style="font-size: 12px;"></i>
                            </vs-button>
                            <template #tooltip>
                                Eliminar registro
                            </template>
                        </vs-tooltip>
                    </div>
                </vs-td>
            </vs-tr>
            </template>
            <template #footer>
                <vs-pagination  v-model="page" :length="pages" />           
            </template>
            <template #notFound>
                Sin registros
            </template>

        </vs-table>
        <editar v-model="activeEditar" :instituciones="instituciones" :selectArrow="selectArrow" @refreshTable="getOfertaAcademicaTable" :csrf_token="csrf_token"></editar>
        <eliminar v-model="activeEliminar" :selectArrow="selectArrow" @refreshTable="getOfertaAcademicaTable" :csrf_token="csrf_token"></eliminar>
    </div>
</template>

<script>
import admisiones from '../../../../api/requests/admisiones.js'
import editar from './modales/editar.vue'
import eliminar from './modales/eliminar.vue'
export default {
    props:[
        'parametros',
        'ejecutar',
        'instituciones',
        'csrf_token',
    ],
    data:() => ({
        users: [],
        page: 1, 
        max: 10,
        pages: 0,
        selectArrow: [],
        activeEditar: false,
        activeEliminar: false
    }),
    components:{
        editar,
        eliminar
    },
    methods:{
        
        async getOfertaAcademicaTable(){
            const loading = this.$vs.loading()
            try {
                const params = {
                   institucion_id: this.parametros.institucion,
                   ciclo_escolar_id: this.parametros.cicloEscolar,
                   page: this.page
                }
                const {data: response} = await admisiones.getOfertaAcademicaTable(params)
                loading.close()
                const { data: dataTable = [], per_page = 20, total = 0 } = response|| {}
                this.pages = Math.ceil(total/per_page) || 0
                this.users = dataTable
            }
            catch{
                loading.close()
            }
        },
    },
    watch:{
        ejecutar(){
            this.getOfertaAcademicaTable()
        },
        page(){
            this.getOfertaAcademicaTable()
        },
    }
}
</script>
